import React from 'react';

export type ResearchGapReceipt = {
  attribute?: string; attributes?: string[]; value?: string; status?: string;
  error?: string; reason?: string; code?: string;
  technical_attribute?: string; category_concept_id?: string; perceived_benefit?: string;
};

export function ResearchGap({gap}: {gap: ResearchGapReceipt}) {
  return <p className="text-amber-700">
    {gap.technical_attribute || gap.attribute || gap.attributes?.join(', ') || 'Research'}
    {gap.category_concept_id && <> → {gap.perceived_benefit ? `${gap.perceived_benefit} (${gap.category_concept_id})` : gap.category_concept_id}</>}
    {gap.value !== undefined && <> — “{gap.value}”</>}
    {gap.status && <> ({gap.status.replace(/_/g,' ')})</>}: {gap.error || gap.reason || gap.code}
    {gap.code && (gap.error || gap.reason) && <> ({gap.code})</>}
  </p>;
}
